import styled from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
export var Verified = styled.div.withConfig({
  displayName: "partials__Verified",
  componentId: "sc-1ly1r3v-0"
})(["position:absolute;bottom:-", "px;right:-", "px;width:", "px;height:", "px;border-radius:", "px;background-color:", ";color:", ";svg{position:absolute;top:", "px;left:", "px;}"], function (_ref) {
  var size = _ref.size;
  return size / 2 - size / 6;
}, function (_ref2) {
  var size = _ref2.size;
  return size / 2 - size / 6;
}, function (_ref3) {
  var size = _ref3.size;
  return size;
}, function (_ref4) {
  var size = _ref4.size;
  return size;
}, function (_ref5) {
  var size = _ref5.size;
  return size;
}, function (_ref6) {
  var theme = _ref6.theme,
    inverted = _ref6.inverted;
  return inverted ? '#fff' : theme.mainColor;
}, function (_ref7) {
  var theme = _ref7.theme,
    inverted = _ref7.inverted;
  return inverted ? theme.mainColor : '#fff';
}, function (_ref8) {
  var size = _ref8.size,
    iconSize = _ref8.iconSize;
  return (size - iconSize) / 2;
}, function (_ref9) {
  var size = _ref9.size,
    iconSize = _ref9.iconSize;
  return (size - iconSize) / 2;
});
export var Label = styled(AppLink).withConfig({
  displayName: "partials__Label",
  componentId: "sc-1ly1r3v-1"
})(["box-sizing:border-box;display:inline-block;position:relative;min-width:96px;height:24px;padding:0 8px;border:1px solid ", ";border-radius:4px;font-size:11px;font-weight:500;line-height:24px;text-align:center;"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.primary;
});